"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingPeriodContent = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var Tooltip_1 = require("../../../../../../../shared/core/components/Tooltip");
var analytics_subjects_1 = require("../../../../../analytics-subjects");
var copy_1 = require("../../../../../copy");
var estimates_1 = require("../../../../../utils/estimates");
var BillBreakdownTable_1 = require("./BillBreakdownTable");
var BillingInsights_1 = require("./BillingInsights");
var BillingPeriodContent_styled_1 = require("./BillingPeriodContent.styled");
var useChargesBreakdown_1 = require("./useChargesBreakdown");
var isComplexMeter = function (period) {
    return period.electricityCharges ? period.electricityCharges.length > 1 : false;
};
var BillingPeriodContent = function (_a) {
    var _b;
    var period = _a.period, latestReadDates = _a.latestReadDates;
    var accountId = (0, ui_tools_1.useAccountContext)().accountId;
    var _c = (0, core_1.useComponents)(), Row = _c.Row, Col = _c.Col, SummaryList = _c.SummaryList, SummaryItem = _c.SummaryItem, Badge = _c.Badge, P = _c.P;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _d = (0, useChargesBreakdown_1.useChargesBreakdown)(period), dataTable = _d.dataTable, totalPositiveCharge = _d.totalPositiveCharge, totalCharge = _d.totalCharge, paymentsReceivedString = _d.paymentsReceivedString, closingBalance = _d.closingBalance, closingBalanceString = _d.closingBalanceString;
    var features = (0, core_1.useFeatureContext)().features;
    var dateFormat = 'yyyy-MM-dd';
    var from = (0, date_fns_1.format)(new Date(period.start), dateFormat);
    var to = (0, date_fns_1.format)(new Date(period.end), dateFormat);
    var periodId = period.periodId;
    var estimationState = (0, estimates_1.getEstimationStates)(latestReadDates, period);
    var estimateInsights = (0, estimates_1.useEstimateInsights)(estimationState);
    var insights = [];
    if (totalCharge < 0) {
        insights.push({
            label: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Copy, { copyKey: "creditBillLabel" }),
                ' ',
                react_1.default.createElement(Tooltip_1.TooltipTrigger, { tooltip: react_1.default.createElement(Copy, { copyKey: "creditInsightTooltip" }) }))),
            status: 'success',
        });
    }
    if (!isComplexMeter(period) && features && features.billingHistoryCallout) {
        insights.push.apply(insights, __spreadArray([], __read(estimateInsights), false));
    }
    if (period.transactions &&
        period.transactions.some(function (transaction) {
            return transaction.description.toLowerCase() === 'energy bill support scheme';
        })) {
        var amount = period.transactions.filter(function (trans) {
            return trans.description.includes('Energy Bill Support Scheme');
        });
        insights.push({
            label: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Copy, { copyKey: "ebssCredit" }),
                ' ',
                react_1.default.createElement(Tooltip_1.TooltipTrigger, { tooltip: react_1.default.createElement(Copy, { copyKey: "ebbsInsightTooltip", values: { amount: amount[0].netCredit.pounds } }) }))),
            status: 'success',
        });
    }
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.BILLING_PERIOD_CONTENT, properties: (_b = {},
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b.estimationState = __assign(__assign({}, estimationState), { switchedOn: Boolean(features && features.billingHistoryCallout) }),
            _b) },
        react_1.default.createElement(Row, { isNested: true, "data-testid": "billing-period-content" },
            react_1.default.createElement(Col, { large: 6 },
                react_1.default.createElement(BillBreakdownTable_1.BillBreakdownTable, { dataTable: dataTable, totalCharge: totalPositiveCharge })),
            react_1.default.createElement(Col, { large: 6 },
                react_1.default.createElement(SummaryList, null,
                    react_1.default.createElement(SummaryItem, { "data-testid": "payments-received", label: react_1.default.createElement(Copy, { copyKey: "paymentsReceivedInPeriod" }) }, paymentsReceivedString),
                    react_1.default.createElement(SummaryItem, { "data-testid": "closing-balance", label: react_1.default.createElement(Copy, { copyKey: "balanceAfterBill" }) }, Number(closingBalance) >= 0 ? (react_1.default.createElement(Copy, { copyKey: "closingBalanceInCredit", values: { closingBalance: closingBalanceString } })) : (react_1.default.createElement(Copy, { copyKey: "closingBalanceInDebit", values: { closingBalance: closingBalanceString } })))),
                react_1.default.createElement(BillingInsights_1.BillingInsights, { insights: insights })),
            react_1.default.createElement(Col, null,
                react_1.default.createElement(BillingPeriodContent_styled_1.StyledLinks, null,
                    period.isStatementAvailable ? (react_1.default.createElement(Copy, { copyKey: "downloadBill", props: { accountId: accountId, from: from, to: to } })) : (react_1.default.createElement(P, null,
                        react_1.default.createElement(Badge, { variant: "warning" },
                            react_1.default.createElement(Copy, { copyKey: "billPending" })))),
                    react_1.default.createElement(Copy, { copyKey: "viewFullBill", props: { periodId: periodId } }),
                    period.isStatementAvailable && (react_1.default.createElement(PaymentLink, { totalCharge: totalCharge })))))));
};
exports.BillingPeriodContent = BillingPeriodContent;
var PaymentLink = function (_a) {
    var totalCharge = _a.totalCharge;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    if (!totalCharge || totalCharge < 0) {
        return null;
    }
    return (react_1.default.createElement(Copy, { copyKey: "payAmount", props: { totalCharge: String(totalCharge) } }));
};
